import React, { useState, DragEvent, ChangeEvent } from 'react';
import api from '../../../components/api';
// import { Button } from '@/components/ui/button'; // optional: using shadcn/ui
// import { UploadCloud } from 'lucide-react'; // optional: using lucide icons

function UploadPage(): React.ReactElement {
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');
  const [dragOver, setDragOver] = useState(false);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0] || null;
    setFile(selectedFile);
    setMessage('');
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragOver(false);
    const droppedFile = e.dataTransfer.files?.[0] || null;
    setFile(droppedFile);
    setMessage('');
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage('Please select a file to upload.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file); // Backend must accept 'file'

    try {
      setUploading(true);
      const response = await api.clients.uploadShopZioOrders(formData);
      setMessage('File uploaded successfully!');
      console.log(response.data);
    } catch (error: any) {
      setMessage('Upload failed. Please try again.');
      console.error(error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: '500px',
        margin: '50px 20px',
        padding: '20px',
        border: '1px solid #ccc',
        borderRadius: '8px',
        textAlign: 'center',
        backgroundColor: '#f9f9f9',
      }}
    >
      <h2>Upload ShopZio Orders</h2>

      <div
        onDragOver={(e) => {
          e.preventDefault();
          setDragOver(true);
        }}
        onDragLeave={() => setDragOver(false)}
        onDrop={handleDrop}
        style={{
          marginTop: '20px',
          padding: '40px 20px',
          border: dragOver ? '2px dashed #007bff' : '2px dashed #aaa',
          borderRadius: '10px',
          backgroundColor: dragOver ? '#e6f0ff' : '#fff',
          color: '#555',
          cursor: 'pointer',
        }}
      >
        {file ? (
          <p>
            Selected File:
            <strong>{file.name}</strong>
          </p>
        ) : (
          <p>Drag and drop a file here, or click below to choose</p>
        )}
        <input
          type="file"
          accept=".zip"
          onChange={handleFileChange}
          style={{ marginTop: '10px' }}
        />
      </div>

      <button
        type="button"
        onClick={handleUpload}
        disabled={uploading || !file}
        style={{
          display: 'block',
          margin: '20px auto 0',
          padding: '10px 20px',
          backgroundColor: uploading || !file ? '#ccc' : '#007bff',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: uploading || !file ? 'not-allowed' : 'pointer',
        }}
      >
        {uploading ? 'Uploading...' : 'Upload'}
      </button>

      {message && <p style={{ marginTop: '15px', fontWeight: 500 }}>{message}</p>}
    </div>
  );
}

export default UploadPage;
